import { RouteConfig } from "vue-router";
import DefaultLayout from "~shared/layouts/DefaultLayout.vue";
import IdentityProvidersEdit from "@/modules/identity-providers/pages/IdentityProvidersEdit.vue";
import IdentityProvidersShow from "@/modules/identity-providers/pages/IdentityProvidersShow.vue";
import IdentityProvidersCreate from "@/modules/identity-providers/pages/IdentityProvidersCreate.vue";
import IdentityProvidersIndex from "./pages/IdentityProvidersIndex.vue";

export const routes: RouteConfig[] = [
  {
    path: "/identity-providers",
    component: DefaultLayout,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "",
        component: IdentityProvidersIndex,
        name: "IdentityProvidersIndex",
      },
      {
        path: ":identityProviderId",
        component: IdentityProvidersShow,
        name: "IdentityProvidersShow",
      },
      {
        path: ":identityProviderId/edit",
        component: IdentityProvidersEdit,
        name: "IdentityProvidersEdit",
      },
      {
        path: "/create",
        component: IdentityProvidersCreate,
        name: "IdentityProvidersCreate",
      },
    ],
  },
];
